module.exports = {
  txt_0001: '加入Edmodo',
  txt_0002: '登录',
  txt_0003: '反馈',
  txt_0004: '简介',
  txt_0005: '查看更多',
  txt_0006: '下载',
  txt_0007: '点击下载产品手册',
  txt_0008: '评论',
  txt_0009: '发表评论',
  txt_0010: '所有评论',
  txt_0011: '好评',
  txt_0012: '中评',
  txt_0013: '差评',
  txt_0014: '首页',
  txt_0015: '尾页',
  txt_0016: '下一页',
  txt_0017: '上一页',
  txt_0018: '版本',
  txt_0019: '即将发布',
  txt_0020: '收起',
  txt_0021: '帮助与反馈',
  txt_0022: '隐私政策',
  txt_0023: '服务条款',
  txt_0024: 'Search in edmodo labs',
  txt_0025: '立即体验',
  txt_0026: '最多只能1024个字符',
  txt_0027: '数据正在加载，请稍等...',
  txt_0028: '网络不给力呀',
  txt_0029: '请联网后再试~',
  txt_0030: '再试试',
  txt_0031: '登录后可以发表评价,',
  txt_0032: '点击',
  txt_0033: '或',
  txt_0034: '注册',
  txt_0035: '产品正在筹备中，敬请期待',
  txt_0036: '评论不能为空',

  txt_0037: 'Edmodo is a global education network that helps connect all learners with the people and resources needed to reach their full potential.',
  txt_0038: 'Edmodo',

  txt_0039: 'Company',
  txt_0040: 'About',
  txt_0041: 'Careers',
  txt_0042: 'Privacy',
  txt_0043: 'Terms Of Service',
  txt_0044: 'Contact Us',

  txt_0045: 'Learn More',
  txt_0046: 'Teachers',
  txt_0047: 'Students',
  txt_0048: 'Parents',
  txt_0049: 'Schools',

  txt_0050: 'Resources',
  txt_0051: 'Spotlight',
  txt_0052: 'Blog',
  txt_0053: 'Support',

  txt_0054: 'Connect',
  txt_0055: 'Twitter',
  txt_0056: 'Facebook',
  txt_0057: '切换账号',
  txt_0058: '退出',

  txt_0059: 'Edmodo Labs Tools',
  txt_0060: 'Get innovative! You might discover your new favorite learning tool.',
  txt_0061: 'More tools coming soon.',
  txt_0062: "We'll be releasing more soon. Follow Edmodo Labs on Edmodo to stay updated on the latest releases!",
  txt_0063: 'Follow Edmodo Labs',
  txt_0064: 'Help create the next generation of edtech tools! At Edmodo Labs, you’ll be among the first to experience emerging edtech tools and software.',
  txt_0065: "See what's new",
  txt_0066: 'Innovating technology with you. ',
  txt_0067: 'Your feedback matters',
  txt_0068: 'We want to build technology that transforms the way you teach and learn. That’s why we need your feedback to help us build better tools. Send us your thoughts and opinions on our latest Edmodo Labs app. ',
  txt_0069: 'Share feedback',
  txt_0070: 'View All',
  txt_0071: 'I’m a Teacher',
  txt_0072: 'I’m a Student',
  txt_0073: 'I’m a Parent',
  txt_0074: 'Coming Soon',

  txt_0075: "What's New",
  txt_0076: '版本历史',
  txt_0077: '版本',
  txt_0078: '更新时间',
  txt_0079: '版本描述',
  txt_0080: '应用信息',
  txt_0081: '大小',
  txt_0082: '兼容性',
  txt_0083: '语言',
  txt_0084: '标签',
  txt_0085: 'Error: The application is off the shelf',

  txt_0086: '选择语言',
  txt_0087: '请输入关键词',
  txt_0088: '暂无结果',
  txt_0089: '没有与您的搜索匹配的结果。',
  txt_0090: '个结果',
  txt_0091: '仅支持电脑端下载'
}



// WEBPACK FOOTER //
// ./src/i18n/zh_CN.js